import ReportHero from "../components/reports/reportHero";

function Reports() {
    return(<div><ReportHero/></div>)
}

export default Reports;